import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  gridItemCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)',
    marginBottom: '10px',
  },
  fullHeightCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardHeader: {
    paddingBottom: '5px',
    paddingLeft: '22px',
  },
  gridItemCardContent: {
    flex: 1,
  },
  fullHeightCardContent: {
    flex: 1,
  },
  codeBlock: {
    fontFamily: 'monospace',
    fontSize: 12,
    lineHeight: 1.5,
    overflowX: 'auto',
    overflowY: 'auto',
    maxHeight: 300,
    backgroundColor: theme.palette.type === 'dark' ? '#1e1e1e' : '#f5f5f5',
    color: theme.palette.type === 'dark' ? '#d4d4d4' : '#333',
    padding: '10px 40px 10px 12px',
    borderRadius: 8,
    margin: 0,
    whiteSpace: 'pre',
    flex: 1,
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3,
      backgroundColor: 'transparent',
      transition: 'background-color 0.4s ease',
    },
    '&$codeBlockScrolling::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(128, 128, 128, 0.5)',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&$codeBlockScrolling': {
      scrollbarColor: 'rgba(128, 128, 128, 0.5) transparent',
    },
  },
  codeBlockScrolling: {},
  inlineCode: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.06)',
    color: theme.palette.type === 'dark' ? '#d4d4d4' : '#333',
    padding: '2px 6px',
    borderRadius: 4,
    wordBreak: 'break-all',
  },
}));
